import { CustomForm, CustomFormGroup } from "@tilby/tilby-ui-lib/components/tilby-magic-form";
import { ProvValidator } from "@tilby/tilby-ui-lib/utilities";
import { Departments, Vat } from "tilby-models";

export class DepartmentsFe implements Departments {
    id?: number = 0;
    name: string = "";
    printer_code?: number = 0;
    code?: string = "";
    display?: boolean = false;
    pms_code?: string = "";
    law_ref?: string = "";
    vat_id: number = 0;
    activity_code_id?: number = 0;
    activity_code?: number = 0;
    sales_type?: Departments.SalesTypeEnum = undefined;
    giftcard_type_uuid?: string = "";
    not_discountable?: boolean = false;
    vat?: Vat = undefined;
}

export type DepartmentsFields = Departments;

export type DepartmentsNullable = { [prop in string & keyof DepartmentsFields]: DepartmentsFields[prop] | null };
export type DepartmentsForm = Partial<CustomForm<DepartmentsNullable>>;

export type DepartmentsFormGroups = CustomFormGroup<DepartmentsForm>;

export interface DepartmentsValidators extends ProvValidator {
    nameMaxLength: number;
    lawRefMaxLength: number;
}

export const READONLY_BE_KEYS = [
    'vat',
    'activity_code'
]

export const filterableDepartmentsColumnsWithSearchBar: (keyof DepartmentsFe)[] = ["name"];